import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class FileService {
  fileUploadingSubject = new BehaviorSubject({});
  constructor(private http: HttpClient) {}

  postFile(file: any, type: string): Observable<any> {
    this.fileUploadingSubject.next({ type, loading: true });
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/files/upload`, formData);
  }
}
